import React from 'react';
import ProductCard from './ProductCard';
import ProductPartItems from './ProductPartItems';
import styled from 'styled-components';
import { SearchSparePart } from '../../services/SparePartService';
import variables from '@ingka/variables/design-tokens';
import useTranslation from '../../hooks/useTranslation';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 700px;
  justify-content: space-between;
  margin-top: 42px;
  margin-bottom: 24px;
  @media (min-width: ${variables.breakpointM}) {
    flex-direction: row;
    padding-right: 32px;
  }
`;

const PartItemsWrapper = styled.div`
  margin-left: 0;
  @media (min-width: ${variables.breakpointM}) {
    margin-left: 48px;
  }
`;

const NoPartItemsFound = styled.div`
  max-width: 255px;
`;

const ProductParts = ({ articleItem }: any) => {
  const { id, productDesc, imageUrl, items, type } = articleItem;
  const { t } = useTranslation();

  return (
    <Container>
      <ProductCard
        name={productDesc}
        imgUrl={imageUrl}
        typeName={type}
        productId={id}
      />

      <PartItemsWrapper>
        {items && <ProductPartItems items={items as SearchSparePart[]} />}
        {!items && (
          <NoPartItemsFound>
            <p>
              {t('spareParts.landingPage.relatedParts.weAreSorry')}
              <br />
              {t('spareParts.landingPage.relatedParts.couldNotFindPart')}
              <br />
              {t(
                'spareParts.landingPage.relatedParts.findPartNumberInInstructions'
              )}
            </p>
          </NoPartItemsFound>
        )}
      </PartItemsWrapper>
    </Container>
  );
};

export default ProductParts;
